import React from 'react';
// Import image directly using ES import
import bridgeImage from '../../../assets/images/bridge.jpeg';

const InfrastructureAnalysis = () => {
    return (
        <div className="analysis-section">
            <div className="analysis-content">
                <h2>Infrastructure Analysis</h2>
                <p>
                    Our Infrastructure Analysis services leverage high-density LiDAR data to create detailed 3D models of built environments, enabling comprehensive assessments of structures, transportation networks, and utility systems with centimeter-level accuracy.
                </p>
                <p>
                    From identifying overhead clearance issues and monitoring settlement in transportation corridors to detecting encroaching vegetation around power lines, our specialized analysis workflows deliver actionable intelligence for infrastructure management, maintenance planning, and risk mitigation.
                </p>
                <p>
                    We extract precise measurements and as-built conditions of bridges, highways, railway corridors, power transmission networks, and water management systems, helping infrastructure managers detect potential problems before they escalate into failures. Our customized deliverables include detailed 3D models, clearance reports, clash detection analyses, and change monitoring for critical infrastructure assets.
                </p>
                <div className="analysis-features">
                    <span className="feature-item">As-Built Documentation</span>
                    <span className="feature-item">Clearance Analysis</span>
                    <span className="feature-item">Encroachment Detection</span>
                    <span className="feature-item">BIM Integration</span>
                    <span className="feature-item">Structural Assessment</span>
                </div>
            </div>
            <div className="analysis-image">
                <img src={bridgeImage} alt="Drone LiDAR Survey of Bridge Infrastructure" />
            </div>
        </div>
    );
};

export default InfrastructureAnalysis;